import JobcaseAgreementModal from './JobcaseAgreementModal';

export default JobcaseAgreementModal;
